import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import localize from "@/utils/localization";
import { DEFAULT_QUOTA_SOURCE_LABEL } from "./model/QuotaUsage";
export default /*#__PURE__*/ _defineComponent({
    __name: 'QuotaUsageBar',
    props: {
        quotaUsage: null,
        embedded: { type: Boolean, default: false },
        compact: { type: Boolean, default: false }
    },
    setup(__props, { expose }) {
        const props = __props;
        const storageSourceText = ref(localize("storage source"));
        const percentOfDiskQuotaUsedText = ref(localize("% of disk quota used"));
        const isDefaultQuota = computed(() => {
            return props.quotaUsage.sourceLabel === DEFAULT_QUOTA_SOURCE_LABEL;
        });
        const quotaHasLimit = computed(() => {
            return !props.quotaUsage.isUnlimited;
        });
        const progressVariant = computed(() => {
            const percent = props.quotaUsage.quotaPercent;
            if (percent === undefined || percent === null) {
                return "secondary";
            }
            if (percent < 50) {
                return "success";
            }
            else if (percent >= 50 && percent < 80) {
                return "primary";
            }
            else if (percent >= 80 && percent < 95) {
                return "warning";
            }
            return "danger";
        });
        const sourceTag = computed(() => {
            return props.embedded ? "div" : "h2";
        });
        const usageTag = computed(() => {
            return props.embedded ? "div" : "h3";
        });
        expose({
            isDefaultQuota,
            quotaHasLimit,
        });
        return { __sfc: true, props, storageSourceText, percentOfDiskQuotaUsedText, isDefaultQuota, quotaHasLimit, progressVariant, sourceTag, usageTag };
    }
});
